<button
  type="button"
  class="btn"
  [ngClass]="class"
  (click)="onClick()"
  [disabled]="isSending"
>
  Publish
</button>
